module.exports = __webpack_public_path__ + "static/media/tools.fe01e470.svg";